// src/utils/fileUtils.js

/**
 * Convert bytes to human readable format
 */
export const formatBytes = (value) => {
  const bytes = Number(value) || 0;
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const size = bytes / Math.pow(1024, i);

  return `${size.toFixed(size < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
};

/**
 * Truncate long file names but keep extension
 * Example:
 * "very_long_filename_document.pdf"
 * -> "very_long_fil...document.pdf"
 */
export const truncateFileName = (name, maxLength = 40) => {
  if (!name) return "";
  if (name.length <= maxLength) return name;

  const extIndex = name.lastIndexOf(".");
  const extension = extIndex !== -1 ? name.slice(extIndex) : "";
  const baseName = extIndex !== -1 ? name.slice(0, extIndex) : name;

  const truncatedLength = maxLength - extension.length - 3;
  const truncatedBase = baseName.slice(0, truncatedLength);

  return `${truncatedBase}...${extension}`;
};

/**
 * Get file mime Type
 */
export const getMimeType = (filename = '') => {
  const ext = filename.split('.').pop().toLowerCase();
  const map = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    txt: 'text/plain',
    csv: 'text/csv',
    html: 'text/html',
  };
  return map[ext] || 'application/octet-stream';
};

/**
 * Get file type icon name (string) based on mime type
 * Useful for icon libraries
 */
export const getFileIcon = (mimeType = "") => {
  const type = String(mimeType).toLowerCase();

  if (type.startsWith("image/")) return "image";
  if (type === "application/pdf") return "pdf";
  if (type.startsWith("text/")) return "text";
  if (type.includes("spreadsheet") || type.includes("excel")) return "excel";
  if (type.includes("word")) return "word";
  if (type.startsWith("video/")) return "video";
  if (type.startsWith("audio/")) return "audio";

  return "file";
};